/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "link-out",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#367C2B"
            },
            "linkOut": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "16",
            "height": "14"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 14", className: "link-out", width: this.props.width, height: this.props.height, style: this.props.linkOut },
            _react2["default"].createElement("path", { className: "st0", d: "M12.7 7.6c-.4 0-.7.4-.7.8v4.1H1.5V4h6.4c.4 0 .8-.3.8-.8s-.4-.7-.8-.7H.7c-.4 0-.7.3-.7.7v10c0 .5.3.8.7.8h12c.4 0 .8-.3.8-.8V8.4c0-.4-.3-.8-.8-.8z", style: this.props.st0 }),
            _react2["default"].createElement("path", { className: "st0", d: "M15.9.5c-.1-.2-.2-.3-.4-.4-.1-.1-.2-.1-.3-.1H9.9c-.4 0-.7.3-.7.8s.3.8.8.8h3.5L8.7 6.2c-.3.3-.3.8 0 1.1.2.1.3.2.5.2s.4-.1.5-.2l4.7-4.7V6c0 .4.3.8.8.8s.8-.3.8-.8V.8c0-.1 0-.2-.1-.3z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/link-out.js